<template>
  <MessageError class="ml-3">{{ errorMessage }}</MessageError>
</template>

<script>
import MessageError from 'UI/MessageError';
export default {
  components: {
    MessageError
  },
  props: {
    errorMessage: {
      type: String,
      default: ''
    }
  }
};
</script>
